import React from 'react'
import { Field } from 'redux-form'

import { translate } from 'parking-react-common'
import { ui, auth, forms } from '../redux'

import form from '../components/Form'
import { Row, Column } from '../components/Grid'
import Input from '../components/Input'
import Button from '../components/Button'
import ResendCodeItem from '../components/ResendCodeItem'

const PhoneVerificationForm = ({ isSubmitting, isPristine, t, dispatch, initialValues }) => (
    <div>
        <Field
            name="code"
            placeholder={ t('The 6 digit verification code') }
            component={ Input }
        />
        <Row>
            <Column span={ 4 }>
                <Button
                    type="submit"
                    label={ t('Submit') }
                    size={ ui.SIZE.large }
                    intent={ ui.INTENT.primary }
                    isBlock
                    disabled={ isSubmitting || isPristine }
                />
            </Column>
            <Column span={ 4 }>
                <ResendCodeItem phone={ initialValues.phone } />
            </Column>
            <Column span={ 4 }>
                <Button
                    label={ t('Cancel') }
                    size={ ui.SIZE.large }
                    onClick={ () => dispatch(auth.cancelPhoneLogin()) }
                    isBlock
                />
            </Column>
        </Row>
    </div>
)


PhoneVerificationForm.propTypes = forms.propTypes

export default translate()(form({ id: forms.phoneVerification.id })(PhoneVerificationForm))
